import React from "react";
import { Link } from "react-router-dom";

const Dish = ({ dish }) => {
  const { id, name, img } = dish;

  return (
    <article className="dish">
      <Link to={`/menu/${id}`}>
        <img src={img} alt={name} className="dish-img" />
      </Link>
      <button className="dish-btn">
        <Link className="dish-link" to={`/menu/${id}`}>
          Details
        </Link>
      </button>
    </article>
  );
};

export default Dish;
